import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Container from '~/App/components/Container';
import Header from '~/App/components/Header';
import { State } from '~/types';
import { ClosingReport } from '~/types/Report';
import message from '../../../../utils/message';
import FixedBottom from '../../../components/FixedBottom';
import SpinnerOverlay from '../../../components/SpinnerOverlay';
import StickyHeader from '../../../components/StickyHeader';
import { fetchClosingReport } from '../../api';
import BottomBar from './components/BottomBar';
import Contents from './components/Contents';

type DataState =
  | {
      type: State.Loading;
    }
  | {
      type: State.Error;
    }
  | {
      type: State.Success;
      data: ClosingReport;
    };

const Closing = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [state, setState] = useState<DataState>({ type: State.Loading });

  useEffect(() => {
    if (!id) {
      setState({ type: State.Error });
      message.error('Tidak ada ID Laporan');
      return;
    }
    setState({ type: State.Loading });
    fetchClosingReport(id).then(({ data, error }) => {
      setState({ type: State.Loading });
      if (error) {
        setState({ type: State.Error });
        message.error(error);
      } else {
        setState({ type: State.Success, data });
      }
    });
  }, [id]);

  return (
    <Container>
      <StickyHeader>
        <Header title="Laporan Tutup Kasir" hideBackButton hideHomeButton />
      </StickyHeader>
      <div style={{ paddingBottom: 100 }}>
        <SpinnerOverlay show={state.type === State.Loading} />
        {state.type === State.Success ? <Contents report={state.data} /> : null}
        {state.type === State.Error ? <span>Gagal memuat laporan</span> : null}
      </div>
      <FixedBottom>
        <BottomBar id={id} />
      </FixedBottom>
    </Container>
  );
};

export default Closing;
